import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReportingComponent } from "./reporting.component";
import { InputWrapperModule } from "@shared/components/input-wrapper/input-wrapper.module";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatIconModule } from "@angular/material/icon";
import { MatLegacyFormFieldModule as MatFormFieldModule } from "@angular/material/legacy-form-field";
import { MatLegacyInputModule as MatInputModule } from "@angular/material/legacy-input";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatLegacyPaginatorModule as MatPaginatorModule } from "@angular/material/legacy-paginator";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FlexLayoutModule } from "ngx-flexible-layout";
import { CustomerLegalEntitySelectModule } from "@shared/components/customer-legal-entity-select/customer-legal-entity-select.module";
import { SharedModule } from "@shared/shared.module";
import { ReportingRoutingModule } from "./reporting-routing.module";
import { MatLegacyTooltipModule as MatTooltipModule } from "@angular/material/legacy-tooltip";
import { BreadcrumbsModule } from "@shared/components/breadcrumbs/breadcrumbs.module";

@NgModule({
	declarations: [ReportingComponent],
	imports: [
		CommonModule,
		InputWrapperModule,
		MatButtonModule,
		MatIconModule,
		MatFormFieldModule,
		MatInputModule,
		MatDatepickerModule,
		MatPaginatorModule,
		FormsModule,
		ReactiveFormsModule,
		FlexLayoutModule,
		CustomerLegalEntitySelectModule,
		SharedModule,
		ReportingRoutingModule,
		MatTooltipModule,
		BreadcrumbsModule
	]
})
export class ReportingModule {}
